import { ApiRequest } from '../baseService'

const BaseRoute = '/app/attachments/attachmentTypes'

const API = {
  GetAll,
  SeedAttachmentTypes,
  GetEmailUploadLogs,
  TestEmailUploadConnection,
  RunEmailUploadNow,
  GetEmailUploadRunState,
  TriggerEmailUpload,
}

function GetAll(params = {}) {
  return ApiRequest.get(`${BaseRoute}`, { params })
}

/** Processing history of the email auto-upload mailbox (host-only). */
function GetEmailUploadLogs(params = {}) {
  return ApiRequest.get('/app/attachments/email-upload-logs', { params })
}

/** Probes the upload mailbox without uploading anything (host-only). */
function TestEmailUploadConnection(tenantId: string, mailbox?: string) {
  return ApiRequest.post(
    '/app/attachments/email-upload/test-connection',
    null,
    {
      params: { tenantId, mailbox },
    }
  )
}

/** Runs one mailbox sweep immediately and reports what it did (host-only). */
function RunEmailUploadNow(tenantId: string, lookbackHours: number) {
  return ApiRequest.post('/app/attachments/email-upload/run-now', null, {
    params: { tenantId, lookbackHours },
  })
}

/** Whether a sweep is running for the caller's own tenant, and when the last one ran. */
function GetEmailUploadRunState() {
  return ApiRequest.get('/app/attachments/email-upload/run-state')
}

/**
 * Queues a sweep for the caller's own tenant. Returns the run state either way — "someone is
 * already running one" comes back as a normal response with queued=false, not as an error.
 */
function TriggerEmailUpload() {
  return ApiRequest.post('/app/attachments/email-upload/trigger')
}

function SeedAttachmentTypes(params = {}) {
  return ApiRequest.post(`app/tenants/seedAttachmentTypes`, { params })
}

export default API
